import { useEffect, useState } from 'react';

interface ShareModalProps {
  title: string;
  onClose: () => void;
}

export default function ShareModal({ title, onClose }: ShareModalProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const link = window.location.href;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} aria-hidden="true" />
      <div className="animate-fade-in relative w-full max-w-md rounded-xl border border-background-700 bg-background-900 p-6">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-lg font-bold text-foreground-50">分享影视</h3>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-300 hover:bg-background-800"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>
        <p className="mt-1 line-clamp-1 text-sm text-foreground-400">《{title}》</p>

        <div className="mt-5 flex items-center gap-1.5 rounded-lg border border-background-700 bg-background-950 px-3 py-2.5">
          <i className="ri-link text-foreground-500" />
          <span className="flex-1 truncate text-xs text-foreground-400">{link}</span>
          <button
            type="button"
            onClick={handleCopy}
            className="flex h-8 shrink-0 items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 text-xs font-semibold text-background-950 transition-colors hover:bg-primary-400"
          >
            <i className={copied ? 'ri-check-line' : 'ri-file-copy-line'} />
            {copied ? '已复制' : '复制'}
          </button>
        </div>

        <div className="mt-5 grid grid-cols-4 gap-4">
          {[
            { icon: 'ri-wechat-line', label: '微信', color: 'text-primary-400' },
            { icon: 'ri-weibo-line', label: '微博', color: 'text-accent-500' },
            { icon: 'ri-qq-line', label: 'QQ', color: 'text-secondary-300' },
            { icon: 'ri-more-line', label: '更多', color: 'text-foreground-300' },
          ].map((item) => (
            <button
              key={item.label}
              type="button"
              onClick={handleCopy}
              className="flex flex-col items-center gap-2"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-800 transition-colors hover:bg-background-700">
                <i className={`${item.icon} text-2xl ${item.color}`} />
              </span>
              <span className="text-xs text-foreground-400">{item.label}</span>
            </button>
          ))}
        </div>

        <p className="mt-5 rounded-lg bg-background-800/70 px-3 py-2.5 text-xs leading-relaxed text-foreground-500">
          提示：点击分享图标即可复制影视链接，粘贴到微信、微博等平台即可分享给好友。本站为演示站点，分享功能仅作展示。
        </p>
      </div>
    </div>
  );
}